/**
 * Wurzelkomponente der React-SPA. Ab Task 7 (Phase 6, "Kopfzeile, Navigation, Marken-Menü, Theme,
 * Anmeldung") delegiert diese Datei an `components/App/App.tsx` - dort entsteht die eigentliche
 * Anwendung, gebaut in kleinen Komponenten je Fläche. Diese Datei bleibt der Vite-Einstiegspunkt
 * (aus `main.tsx` importiert).
 *
 * Seit dem Merge der Tasks 7-9 legt sie zusätzlich den Store (`<Speicher>`, Task 8) um die
 * Anwendung. Bewusst HIER und nicht in `main.tsx`: `main.tsx` montiert in `document.body` selbst
 * (siehe dortiger Kopfkommentar) und lässt sich deshalb nicht rendern, ohne das Testdokument als
 * Ganzes zu übernehmen - diese Datei dagegen ist eine gewöhnliche Komponente. Der Nachweis, dass der
 * Store tatsächlich um die App liegt (`test/komponenten/App/app.test.tsx`, erster Fall), rendert
 * genau sie; ohne den `<Speicher>` hier wirft `useSpeicher()` in `components/App/App.tsx`, die
 * `<FehlerGrenze>` zeigt ihre Fläche statt der Anmeldemaske, und der Fall fällt.
 *
 * OHNE `dienste`-Prop: es greifen `STANDARD_DIENSTE` (echter SSE-Strom auf `/api/events`, echtes
 * gezieltes Nachladen über `api/`). Tests reichen ihre eigenen Attrappen herein, indem sie
 * `components/App/App.tsx` direkt in einen eigenen `<Speicher dienste={...}>` stellen.
 *
 * Neben dem `<Speicher>` steht der `<FehlerStapel />` (Fehleranzeige Paket 1, Spec 2026-10-19): HIER,
 * als Geschwister und nicht innerhalb von `components/App/App.tsx`, damit er auf jeder Fläche
 * erscheint, auch auf der Anmeldemaske. Er braucht den Store nicht - sein Speicher liegt auf
 * Modulebene (`state/fehlerStapel.ts`) und ist auch aus `api/*` erreichbar. Leer rendert er `null`.
 *
 * Um den `<Speicher>` liegt die `<FehlerGrenze>` (Spec Abschnitt 3): stuerzt die Anwendung beim
 * Rendern ab, zeigt sie eine Fehlerflaeche statt der weissen Seite. Der `<FehlerStapel />` steht
 * bewusst AUSSERHALB der Grenze und bleibt bei einem Absturz sichtbar.
 *
 * Der globale Fehlerfaenger (`lib/globalerFehlerfaenger.ts`) wird hier installiert, in einem
 * `useEffect` mit Abbau beim Unmount - StrictMode installiert, baut ab und installiert erneut.
 */
import { useEffect } from "react";
import { Speicher } from "./state/Speicher.tsx";
import { App as Anwendung } from "./components/App/App.tsx";
import { FehlerGrenze } from "./components/App/FehlerGrenze.tsx";
import { FehlerStapel } from "./components/App/FehlerStapel.tsx";
import { installiereGlobalenFehlerfaenger } from "./lib/globalerFehlerfaenger.ts";

export default function App() {
  useEffect(() => installiereGlobalenFehlerfaenger(), []);

  return (
    <>
      <FehlerGrenze>
        <Speicher>
          <Anwendung />
        </Speicher>
      </FehlerGrenze>
      <FehlerStapel />
    </>
  );
}
